import { AbilitySubject, every, not } from "@cdv/jazz-auth";
import { User } from "../../api";
import { isAppuser } from "../utils";

export default function defineCompanyUserAbility(can: AbilitySubject<User>): void {
  can("update", isAppuser);
}
